import { render, staticRenderFns } from "./Ukraine1946.vue?vue&type=template&id=5edb3e39&"
import script from "./Ukraine1946.vue?vue&type=script&lang=js&"
export * from "./Ukraine1946.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports